import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "subTitle", "state", "icon", "children", "additionalContent", "actionGetters", "actions", "buttonGetters", "buttons", "className"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { statusViewPropState } from "./types";
import { composePreparedProps } from "./utils";
import styles from "./styles.pcss";
import { StatusViewButtons } from "./StatusViewButtons";
import { StatusViewContent } from "./StatusViewContent";
var cnStatusView = cnBem('status-view', styles);
var StatusViewRender = function StatusViewRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    title = _composePreparedProps.title,
    subTitle = _composePreparedProps.subTitle,
    _composePreparedProps2 = _composePreparedProps.state,
    state = _composePreparedProps2 === void 0 ? statusViewPropState[0] : _composePreparedProps2,
    icon = _composePreparedProps.icon,
    children = _composePreparedProps.children,
    additionalContent = _composePreparedProps.additionalContent,
    actionGetters = _composePreparedProps.actionGetters,
    actions = _composePreparedProps.actions,
    buttonGetters = _composePreparedProps.buttonGetters,
    buttons = _composePreparedProps.buttons,
    className = _composePreparedProps.className,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var isMobile = useIsMobileDimension();
  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement(StatusViewContent, _extends({
      actions: actions,
      additionalContent: additionalContent,
      icon: icon,
      state: state,
      subTitle: subTitle,
      title: title
    }, actionGetters, {
      "data-t-id": "components-StatusView"
    }), children);
  };
  return /*#__PURE__*/React.createElement("section", _extends({
    className: cnStatusView(null, [className]),
    ref: ref
  }, otherProps), isMobile ? /*#__PURE__*/React.createElement("div", {
    className: cnStatusView('wrapper')
  }, renderContent()) : renderContent(), /*#__PURE__*/React.createElement(StatusViewButtons, _extends({
    buttons: buttons,
    className: cnStatusView('buttons')
  }, buttonGetters)));
};
export var StatusView = /*#__PURE__*/forwardRef(StatusViewRender);